import { TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { AdaptivaUrlRequiredPipe, ContentIdRequiredPipe, DisplayAuthoringPropertyPipe, FileNameRequiredPipe, InheritPipe, IsRequiredPropertyPipe, UploadAllowedPipe, VendorUrlRequiredPipe } from '@adaptiva/metadata/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { FileUploaderComponentModule } from '@adaptiva/widgets/file-uploader';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { ContentPropertiesComponent } from './content-properties.component';

const widgets = [
	CardComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ComboComponentModule,
	AuthoringPropertyLabelComponentModule,
	LabelComponentModule,
	FileUploaderComponentModule,
	OverlayComponentModule,
	ButtonComponentModule,
];

@NgModule({
	imports: [
		...widgets,
		AdaptivaUrlRequiredPipe,
		CommonModule,
		ContentIdRequiredPipe,
		DisplayAuthoringPropertyPipe,
		FileNameRequiredPipe,
		InheritPipe,
		IsRequiredPropertyPipe,
		TemplateMarkerDirectiveModule,
		UploadAllowedPipe,
		VendorUrlRequiredPipe,
	],
	declarations: [ContentPropertiesComponent],
	exports: [ContentPropertiesComponent]
})
export class ContentPropertiesComponentModule {

}
